import React from 'react';
import { useLocation, Redirect } from 'react-router-dom';
import { initial, compact } from 'lodash';

const DetailsRedirect = () => {
  const location = useLocation();

  return (
    <Redirect to={`/${initial(compact(location.pathname.split('/'))).join('/')}/details`} />
  );
};

export default DetailsRedirect;
